import styled from 'styled-components';

import { Text } from 'src/client/components';
import {
  GALLERY_THEME_COLOR_VALUES,
  GalleryColor,
} from 'src/commons/constants/gallery';

type FooterSectionProps = {
  color: string;
};

export const FooterText = styled(Text)`
  font-family: 'SF Pro';
  font-size: 14px;
  font-weight: 510;
  line-height: 120%; /* 16.8px */
`;

export const FooterSection = styled.section<FooterSectionProps>`
  width: 100%;
  height: 75px;
  background: ${(props) => props.color};

  display: flex;
  align-items: center;
  padding: 24px 28px;

  & ${FooterText} {
    color: ${(props) =>
      props.color == GALLERY_THEME_COLOR_VALUES[GalleryColor.COLOR_3]
        ? props.theme.colors.darkEmphasis1
        : 'white'};
  }
`;
